<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
<path d="M7.9987 8.00065V12.0007L5.33203 13.334M14.6654 12.0007C14.6654 15.6825 11.6806 18.6673 7.9987 18.6673C4.3168 18.6673 1.33203 15.6825 1.33203 12.0007C1.33203 8.31875 4.3168 5.33398 7.9987 5.33398C11.6806 5.33398 14.6654 8.31875 14.6654 12.0007Z" stroke="#6782F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>